var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'bookmark-button v-toolbar__button',
    { '--bookmarked': _vm.isBookmarked || _vm.isBookmarking }
  ],attrs:{"data-cy":"bookmark-button"},on:{"click":_vm.bookmark}},[(_vm.isBookmarking)?[_c('v-loader')]:(_vm.isBookmarked)?[_c('v-icon',{attrs:{"icon":"beenhere"}})]:[_c('v-icon',{attrs:{"icon":"bookmark"}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }